import DisplayModeToggle from './DisplayModeToggle.component';

export default DisplayModeToggle;
